import moment from 'moment';
import { DimensionFilter, UserDimension, } from 'modules/analytics/models/dimensions';
import { getChannelNameFromSource, getName, } from 'modules/application/detail/users/UserUtils';
import { UsersControllerModel } from 'modules/application/detail/users/UsersControllerModel';
import { UserProperties } from 'modules/application/detail/users/models/UserProperties';
// Misc
import buildQuery from 'odata-query';
import { buildComparisonOData, matchODataFunction, ODataOperator, ODataFunction, } from 'types/OData';
import { userDetailStateName } from '.';
// Style
import './Users.scss';
import { setupPeriodToCookies, setupDaterangePickerPeriod } from 'modules/analytics/Utils';
import { UserFeatures } from './UserFeatures';
import { getFormatDateTime } from 'data/date';
import { ToastType } from 'modules/application/misc/ToastService';
// Constants
const USER_FILTER_KEY = 'userFilterKey';
const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY HH:mm:ss';
const PICKER_HAS_TIME = true;
const FISRT_DAY_WITH_CONTACTS_DATA = '2019-01-01';
const validStartFromToday = moment(FISRT_DAY_WITH_CONTACTS_DATA).diff(moment(), 'days');
const PERIOD_CONSTANTS = {
    defaultStartFromToday: -7,
    defaultEndFromToday: 0,
    validStartFromToday,
    validEndFromToday: 1,
};
export class UsersController extends UsersControllerModel {
    static $inject = ['application', 'LoadingService', 'UsersService', 'UsersSegmentService', '$timeout', '$translate', '$state', '$cookies', 'TranslateService', 'BlipToastService', '$stateParams'];
    constructor(application, LoadingService, UsersService, UsersSegmentService, $timeout, $translate, $state, $cookies, TranslateService, BlipToastService, $stateParams) {
        'ngInject';
        super(); //Controller model
        this.application = application;
        this.LoadingService = LoadingService;
        this.UsersService = UsersService;
        this.UsersSegmentService = UsersSegmentService;
        this.$timeout = $timeout;
        this.$translate = $translate;
        this.$state = $state;
        this.$cookies = $cookies;
        this.TranslateService = TranslateService;
        this.BlipToastService = BlipToastService;
        this.$stateParams = $stateParams;
        this.filterChanged = false;
        this.isUsersListReactEnabled = false;
        this.isFirstTimeLoadingContacts = true;
        this.isContactTaxDocumentEnabled = false;
        this.cookiesPeriodKeyContacts = `${this.application.shortName}_contactsPeriodSetting`;
        this.UsersSegmentService.setApplication(this.application);
    }
    async $onInit() {
        this.loadData();
        this.checkUserIdentityParam();
        await this.checkFeatures();
    }
    loadPeriodAndApplyFilter() {
        /* When 'this.dateRangePickerPeriod' receives its value, the 'blip-daterange-picker' calls 'this.applyDateRangeFilter()' and the search is made.
        This is defined in attribute 'on-date-selection' inside 'blip-daterange-picker'*/
        this.daterangePickerPeriod = setupDaterangePickerPeriod(PERIOD_CONSTANTS, this.$cookies, this.cookiesPeriodKeyContacts, PICKER_HAS_TIME);
    }
    async checkFeatures() {
        this.isShowingContactsLastInteraction = await UserFeatures.isShowingContactsLastInteraction();
        this.isContactTaxDocumentEnabled = await UserFeatures.isContactTaxDocumentEnabled();
        this.isUsersListReactEnabled = await UserFeatures.isReactOnContactsPageEnabled();
    }
    checkUserIdentityParam() {
        if (this.$stateParams.userIdentity) {
            this.goToUserDetails(this.$stateParams.userIdentity);
        }
    }
    loadData() {
        this.loadFilterCookie();
        this.loadPeriodAndApplyFilter();
    }
    async applyDateRangeFilter() {
        try {
            if (!this.isFirstTimeLoadingContacts) {
                this.trackAnalyticsContactsDateChanged();
            }
            this.isFirstTimeLoadingContacts = false;
            const start = moment(this.daterangePickerPeriod.selectedPeriod.startDate).format(DEFAULT_DATE_FORMAT);
            const end = moment(this.daterangePickerPeriod.selectedPeriod.endDate).format(DEFAULT_DATE_FORMAT);
            this.searchPeriod = {
                start,
                end,
            };
            /**
             * Get current period and put to cookies object
             */
            setupPeriodToCookies({
                $cookies: this.$cookies,
                period: this.searchPeriod,
                key: this.cookiesPeriodKeyContacts,
            });
            this.applyFilter();
        }
        catch (e) {
            console.error(`Error while applying daterange filter: ${e}`);
        }
    }
    loadFilterCookie() {
        const filterCookieObject = this.$cookies.getObject(USER_FILTER_KEY);
        let userDimension = undefined;
        if (filterCookieObject &&
            filterCookieObject.id === this.application.shortName) {
            userDimension = filterCookieObject.userDimension;
            if (userDimension.filters) {
                userDimension.filters = userDimension.filters.map((filter) => {
                    return new DimensionFilter(filter);
                });
            }
        }
        this.userDimension = new UserDimension(userDimension);
    }
    onFilterChanges({ changes }) {
        this.filterChanged = this.userDimensionIsValid(this.userDimension);
    }
    async applyFilter() {
        const filterCookieObject = {
            id: this.application.shortName,
            userDimension: this.userDimension,
        };
        this.$cookies.putObject(USER_FILTER_KEY, filterCookieObject, {
            expires: new Date(moment(new Date())
                .add(1, 'day')
                .toDate()),
        });
        await this.query();
        this.trackFilterApplied();
        this.filterChanged = false;
    }
    userDimensionIsValid(userDimension) {
        return (userDimension.type != undefined &&
            userDimension.filters.every((f) => f.condition && f.prop && f.value));
    }
    isImageValid(user) {
        if (!user || !user.photoUri) {
            return false;
        }
        return true;
    }
    getName(user) {
        return getName(user);
    }
    getFormatedLastInteraction(user) {
        return getFormatDateTime(user.lastMessageDate, this.TranslateService.getCurrentLanguage());
    }
    getChannelNameFromSource(user) {
        return getChannelNameFromSource(user.source);
    }
    async loadMore() {
        if (!this.canLoadMore || this.isLoading) {
            return;
        }
        this.perPageAux += this.itemsPerPage;
        this.query(false);
    }
    disableLoader() {
        return this.isLoading || !this.canLoadMore;
    }
    getFilters() {
        const labeledFilters = this.getLabeledFilters();
        const extrasFilter = this.getExtrasFilter(labeledFilters);
        const propFilter = this.getPropFilter(labeledFilters);
        const filterQuery = buildQuery({ filter: propFilter });
        return this.getFinalQuery(filterQuery, extrasFilter);
    }
    getLabeledFilters() {
        const userProps = UserProperties.getPropsWithDocument();
        return this.userDimension.filters.map(f => {
            return {
                isExtra: f.condition && f.prop && f.value && !userProps.includes(f.prop),
                value: f,
            };
        });
    }
    getExtrasFilter(labeledFilters) {
        return labeledFilters.filter(f => f.isExtra)
            .map(f => f.value)
            .map(f => {
            const extraModificator = f.condition === ODataOperator.NotEquals ||
                f.condition === ODataFunction.NotContains
                ? 'not '
                : '';
            return `${encodeURIComponent(extraModificator + f.prop.replace(/^extras\./i, ''))}=${encodeURIComponent(f.value)}`;
        });
    }
    getPropFilter(labeledFilters) {
        return labeledFilters.filter(f => !f.isExtra)
            .map(f => f.value)
            .reduce((acc, f) => {
            if (!(f.condition && f.prop && f.value)) {
                return acc;
            }
            const prop = f.prop.toLowerCase();
            const comparisonFunction = buildComparisonOData(f.condition, prop, f.value);
            const queryObject = {
                [`${prop}`]: {
                    [f.condition]: f.value,
                },
            };
            const propertyFilter = matchODataFunction(f.condition)
                ? comparisonFunction
                : queryObject;
            const normalQuery = [...acc, propertyFilter];
            return normalQuery;
        }, []);
    }
    getFinalQuery(filterQuery, extrasFilter) {
        let finalQuery = '&$filter=';
        filterQuery = decodeURIComponent(filterQuery);
        if (filterQuery) {
            let filterQueryContent = filterQuery.split('?$filter=')[1];
            filterQueryContent += ' and ';
            const encodedQueryContent = encodeURIComponent(filterQueryContent);
            finalQuery += `${encodedQueryContent}`;
        }
        const excludeAttendantsQuery = encodeURIComponent("(source ne 'blip.ai' or source eq null)");
        finalQuery += excludeAttendantsQuery;
        const { start, end } = this.searchPeriod;
        finalQuery += encodeURIComponent(` and (lastmessagedate ge datetimeoffset'${moment(start, DEFAULT_DATE_FORMAT).toISOString()}') `);
        finalQuery += encodeURIComponent(` and (lastmessagedate le datetimeoffset'${moment(end, DEFAULT_DATE_FORMAT).toISOString()}') `);
        const extrasQuery = extrasFilter.join('&');
        finalQuery += extrasQuery ? '&' + extrasQuery : '';
        return finalQuery;
    }
    async query(reset = true) {
        this.canLoadMore = true;
        this.LoadingService.startLoading();
        if (reset) {
            this.perPageAux = 0;
            this.users = [];
        }
        try {
            this.isLoading = true;
            const filters = this.getFilters();
            const { items, total } = await this.UsersService.getUsers(filters, this.perPageAux, this.itemsPerPage);
            if (items.length == 0) {
                this.canLoadMore = false;
            }
            this.totalItems = total || 0;
            this.users.push(...items);
            this.usersJSONString = JSON.stringify(this.users);
        }
        catch (e) {
            this.users = [];
            this.totalItems = 0;
            if (e.code != 67) {
                this.BlipToastService.show(ToastType.Danger, {
                    msg: await this.$translate('users.queryUsersError'),
                });
            }
            console.error(e);
        }
        finally {
            /**
             * This $timeout is used to get an user feedback, because loadingIcon component is
             * too fast to be showed while loading
             */
            this.$timeout(function () {
                this.isLoading = false;
                this.LoadingService.stopLoading();
            }.bind(this), 500);
        }
    }
    trackRefreshAndQuery() {
        this.trackRefreshed();
        this.query();
    }
    goToUserDetails(identity) {
        if (!identity) {
            return;
        }
        const id = this.UsersService.getDecodedUserIdentity(identity);
        this.$state.go(userDetailStateName, {
            id,
            userIdentity: undefined,
        });
        this.trackContactClickedOnCard();
    }
    openInNewTab(identity, $event) {
        if (!identity) {
            return;
        }
        const id = this.UsersService.getDecodedUserIdentity(identity);
        const url = this.$state.href(userDetailStateName, {
            id,
        });
        window.open(url, '_blank');
        this.trackContactClickedOnNewTabIcon();
        $event.stopPropagation();
    }
    // Segment
    trackFilterApplied() {
        this.UsersSegmentService.trackFilterApplied();
    }
    trackRefreshed() {
        this.UsersSegmentService.trackRefreshed();
    }
    trackAnalyticsContactsDateChanged() {
        this.UsersSegmentService.trackAnalyticsContactsDateChanged();
    }
    trackContactClickedOnCard() {
        this.UsersSegmentService.trackUserClicked({ 'isNewTab': false });
    }
    trackContactClickedOnNewTabIcon() {
        this.UsersSegmentService.trackUserClicked({ 'isNewTab': true });
    }
}
UsersController.$inject = ['application', 'LoadingService', 'UsersService', 'UsersSegmentService', '$timeout', '$translate', '$state', '$cookies', 'TranslateService', 'BlipToastService', '$stateParams'];
export class User {
    static $inject = ['identity', 'name', 'email', 'gender', 'phoneNumber', 'source'];
    constructor(identity, name, email, gender, phoneNumber, source) {
        this.identity = identity;
        this.name = name;
        this.email = email;
        this.gender = gender;
        this.phoneNumber = phoneNumber;
        this.source = source;
    }
}
